import axios from 'axios';
import {
  PROVISIONAL_BILLING_MY_RECORDS_REQUEST,
  PROVISIONAL_BILLING_MY_RECORDS_SUCCESS,
  PROVISIONAL_BILLING_MY_RECORDS_FAIL,
  PROVISIONAL_BILLING_SUBMIT_REQUEST,
  PROVISIONAL_BILLING_SUBMIT_SUCCESS,
  PROVISIONAL_BILLING_SUBMIT_FAIL,
  PROVISIONAL_BILLING_BULK_UPDATE_REQUEST,
  PROVISIONAL_BILLING_BULK_UPDATE_SUCCESS,
  PROVISIONAL_BILLING_BULK_UPDATE_FAIL,
  PROVISIONAL_BILLING_SUPERVISOR_BANKS_REQUEST,
  PROVISIONAL_BILLING_SUPERVISOR_BANKS_SUCCESS,
  PROVISIONAL_BILLING_SUPERVISOR_BANKS_FAIL,
  PROVISIONAL_BILLING_ALL_RECORDS_REQUEST,
  PROVISIONAL_BILLING_ALL_RECORDS_SUCCESS,
  PROVISIONAL_BILLING_ALL_RECORDS_FAIL,
} from '../constants/provisionalBillingConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const authConfig = (userInfo) => ({
  headers: { Authorization: `Bearer ${userInfo.token}` },
});

const authJsonConfig = (userInfo) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userInfo.token}`,
  },
});

export const fetchMyProvisionalBillingRecords = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: PROVISIONAL_BILLING_MY_RECORDS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/provisional-billing/my-records?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: PROVISIONAL_BILLING_MY_RECORDS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PROVISIONAL_BILLING_MY_RECORDS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const submitProvisionalBillingRecords = (payload) => async (dispatch, getState) => {
  try {
    dispatch({ type: PROVISIONAL_BILLING_SUBMIT_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(`${API_URL}/provisional-billing/submit`, payload, authJsonConfig(userInfo));
    dispatch({ type: PROVISIONAL_BILLING_SUBMIT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PROVISIONAL_BILLING_SUBMIT_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const bulkUpdateProvisionalBillingRecords = (sections) => async (dispatch, getState) => {
  try {
    dispatch({ type: PROVISIONAL_BILLING_BULK_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(`${API_URL}/provisional-billing/bulk-update`, { sections }, authJsonConfig(userInfo));
    dispatch({ type: PROVISIONAL_BILLING_BULK_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PROVISIONAL_BILLING_BULK_UPDATE_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const fetchProvisionalBillingSupervisorBanks = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: PROVISIONAL_BILLING_SUPERVISOR_BANKS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/provisional-billing/supervisor-banks?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: PROVISIONAL_BILLING_SUPERVISOR_BANKS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PROVISIONAL_BILLING_SUPERVISOR_BANKS_FAIL, payload: error.response?.data?.message || error.message });
  }
};

export const fetchAllProvisionalBillingRecords = (month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: PROVISIONAL_BILLING_ALL_RECORDS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/provisional-billing/all-records?month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: PROVISIONAL_BILLING_ALL_RECORDS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: PROVISIONAL_BILLING_ALL_RECORDS_FAIL, payload: error.response?.data?.message || error.message });
  }
};
